import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSearch,
  faPlus,
  faEllipsisH,
  faEdit,
  faTrashAlt,
  faEye,
} from "@fortawesome/free-solid-svg-icons";
import {
  Col,
  Nav,
  Row,
  Form,
  Pagination,
  Card,
  Table,
  Button,
  ButtonGroup,
  Modal,
  InputGroup,
  Dropdown,
  Badge,
} from "@themesberg/react-bootstrap";
import { Link } from "react-router-dom";
import { Routes } from "../../routes";
import axios from "axios";
import Loader from "../../components/Loader";
import {
  getAssets,
  deleteAsset,
  createAssetAssign,
  getVendorList,
} from "../../app/api";
import Select from "react-select";

import swal from "sweetalert";
export default () => {
  const [show, setShow] = useState(false);
  const [vendorId, setVendorID] = useState("");
  const [assetId, setAssetID] = useState([]);
  const [vendor, setVendor] = useState([]);

  const [assets, setAssets] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalPages, setTotalPages] = useState(0); // State to hold total pages
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [loadingBtn, setLoadingBtn] = useState(false);
  useEffect(() => {
    const fetchvendorsList = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem("token");
        const response = await axios.get(getVendorList(), {
          headers: {
            "secret-key": process.env.REACT_APP_SECRET_KEY,
            "auth-token": `Bearer ${token}`,
          },
        });
        // console.log("vendor dropdown", response.data?.data);
        setVendor(response.data?.data);
      } catch (error) {
        // console.error("Error fetching vendors:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchvendorsList();
  }, []);
  const fetchAssets = async (currentPage) => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      const response = await axios.get(getAssets(), {
        headers: {
          "secret-key": process.env.REACT_APP_SECRET_KEY,
          "auth-token": `Bearer ${token}`,
        },
        params: {
          page: currentPage, // Send the current page as a query parameter
          search,
        },
      });
      // console.log(response.data);

      setAssets(response.data?.data);
      setTotalPages(response.data?.pagination?.total_pages);
    } catch (error) {
      // console.error("Error fetching vendors:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchAssets(page);
  }, [page, search]);
  const handleDelete = async (id) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axios.delete(deleteAsset(id), {
        headers: {
          "secret-key": process.env.REACT_APP_SECRET_KEY,
          "auth-token": `Bearer ${token}`,
        },
      });
      console.log(response);
      swal({
        text: response.data.message,
        icon: "success",
      });
    } catch (error) {
      // console.error("Error fetching vendors:", error);
      swal({
        text: error.response.data.messages.error,
        icon: "error",
      });
    }
    fetchAssets(page);
  };
  const handleClose = () => setShow(false);
  const handleShow = (id) => {
    setShow(true);
    setAssetID(id);
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoadingBtn(true);

    try {
      const token = localStorage.getItem("token");
      const assetIdsArray = Array.isArray(assetId) ? assetId : [assetId];
      const AssestsData = {
        vendor_id: vendorId,
        asset_ids: assetIdsArray,
      };
      let response;

      response = await axios.post(createAssetAssign(), AssestsData, {
        headers: {
          "Content-Type": "application/json", // Set Content-Type to application/json
          "secret-key": process.env.REACT_APP_SECRET_KEY, // Include the secret-key
          "auth-token": `Bearer ${token}`,
        },
      });
      swal({
        text: response.data.message,
        icon: "success",
      }).then(() => {
        fetchAssets(page); // Re-fetch vendors instead of reloading the page
      });

      console.log(response.data);
    } catch (error) {
      swal({
        text: error.response.data.messages.error,
        icon: "error",
      });
    } finally {
      setLoadingBtn(false);
      setShow(false);
    }
  };
  return (
    <>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center mb-2">
        <div className="d-block  mb-md-0">
          <h4 className="mb-0">Assets Management</h4>
        </div>
        <Col xs={12} md={4} lg={4} xl={4} className=" mb-sm-2">
          <InputGroup>
            <InputGroup.Text>
              <FontAwesomeIcon icon={faSearch} />
            </InputGroup.Text>
            <Form.Control
              onChange={(e) => setSearch(e.target.value)}
              type="text"
              placeholder="Search"
            />
          </InputGroup>
        </Col>
        <Button
          variant="primary"
          className=" me-2"
          as={Link}
          to={Routes.AssetsAdd.path}
        >
          <FontAwesomeIcon icon={faPlus} className="me-2" />
          <span>New</span>
        </Button>
      </div>

      {/* <div className="table-settings mb-4">
        <Row className="justify-content-between align-items-center">
          <Col xs={8} md={6} lg={3} xl={4}>
            <InputGroup>
              <InputGroup.Text>
                <FontAwesomeIcon icon={faSearch} />
              </InputGroup.Text>
              <Form.Control
                onChange={(e) => setSearch(e.target.value)}
                type="text"
                placeholder="Search"
              />
            </InputGroup>
          </Col>
        </Row>
      </div> */}
      <Card border="light" className="table-wrapper table-responsive shadow-sm">
        <Card.Body className="p-0">
          <Table hover className="user-table align-items-center">
            {loading ? (
              <div className="d-flex justify-content-center">
                <Loader />
              </div>
            ) : (
              <>
                <thead>
                  <tr>
                    <th className="border-bottom">Title</th>

                    <th className="border-bottom">Type</th>
                    <th className="border-bottom">Serial #</th>
                    <th className="border-bottom">MAC Address</th>
                    <th className="border-bottom">VIN #</th>
                    <th className="border-bottom">Status</th>
                    {/* <th className="border-bottom">Assign Assets</th> */}
                    <th className="border-bottom">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {assets?.map((asset, index) => (
                    <tr key={index}>
                      <td className="fw-normal">
                        <Link
                          className="Link_underline"
                          to={`${Routes.AssetsDetail.path}/${asset.id}`}
                        >
                          {asset.title}
                        </Link>
                      </td>

                      <td>
                        <span className="fw-normal">{asset.type}</span>
                      </td>
                      <td>
                        <span className="fw-normal">{asset.serial_no}</span>
                      </td>
                      <td>
                        <span className="fw-normal">{asset.mac_address}</span>
                      </td>
                      <td>
                        <span className="fw-normal">{asset.vin}</span>
                      </td>
                      <td>
                        <span className="fw-normal">
                          {" "}
                          <Badge
                            pill
                            bg={
                              asset.status === "exposed" ||
                              asset.status === "sold"
                                ? "light"
                                : asset.status === "assigned"
                                ? "danger"
                                : "primary"
                            }
                            style={{
                              padding: "0.4rem 1rem",
                              fontSize: "0.85rem",
                              border: "1px solid #ddd",
                            }}
                          >
                            {asset.status === "assigned"
                              ? !asset.vendor_name
                                ? `${asset.status} to no vendor`
                                : `${asset.status} to ${asset.vendor_name}`
                              : asset.status}
                          </Badge>
                        </span>
                        {asset.status === "assigned" && asset.vendor_name ? (
                          <></>
                        ) : (
                          <span className="fw-normal">
                            {" "}
                            <Badge
                              pill
                              bg="success"
                              style={{
                                padding: "0.4rem 1rem",
                                fontSize: "0.85rem",
                                border: "1px solid #ddd",
                                cursor: "pointer",
                              }}
                              onClick={() => handleShow(asset.id)}
                            >
                              Assign
                            </Badge>
                          </span>
                        )}
                      </td>
                      {/* <td>
                       
                      </td> */}
                      <td>
                        <Dropdown as={ButtonGroup}>
                          <Dropdown.Toggle
                            as={Button}
                            split
                            variant="link"
                            className="text-dark m-0 p-0"
                          >
                            <span className="icon icon-sm">
                              <FontAwesomeIcon
                                icon={faEllipsisH}
                                className="icon-dark"
                              />
                            </span>
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            <Dropdown.Item>
                              <Link
                                className="me-2"
                                to={`${Routes.AssetsDetail.path}/${asset.id}`}
                              >
                                {" "}
                                <FontAwesomeIcon
                                  icon={faEye}
                                  className="me-2"
                                />{" "}
                                View Details
                              </Link>
                            </Dropdown.Item>
                            <Dropdown.Item>
                              <Link
                                as={Link}
                                to={`${Routes.AssetsAdd.path}/${asset.id}`}
                              >
                                <FontAwesomeIcon
                                  icon={faEdit}
                                  className="me-2"
                                />{" "}
                                Edit
                              </Link>
                            </Dropdown.Item>
                            <Dropdown.Item className="text-danger">
                              <div onClick={() => handleDelete(asset.id)}>
                                <FontAwesomeIcon
                                  icon={faTrashAlt}
                                  className="me-2"
                                />{" "}
                                Remove
                              </div>
                            </Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </>
            )}
          </Table>
          <Card.Footer className="px-3 border-0 d-lg-flex align-items-center justify-content-center">
            <Nav className="justify-content-center mb-4">
              <Pagination className="mb-2 mb-lg-0">
                <Pagination.Prev
                  onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
                />
                {Array.from({ length: totalPages }, (_, index) => (
                  <Pagination.Item
                    key={index + 1}
                    active={index + 1 === page}
                    onClick={() => setPage(index + 1)}
                  >
                    {index + 1}
                  </Pagination.Item>
                ))}
                <Pagination.Next
                  onClick={() =>
                    setPage((prev) => Math.min(prev + 1, totalPages))
                  }
                />
              </Pagination>
            </Nav>
          </Card.Footer>
        </Card.Body>
      </Card>
      <Modal className="p-3 modal-cont" show={show} onHide={handleClose}>
        <Modal.Header className="p-3 contact_header">
          <Modal.Title className="contact_header_title">
            Assign Assets
          </Modal.Title>
          <Button
            variant="danger"
            onClick={handleClose}
            className="contact_header_Btn"
          >
            &times;
          </Button>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex align-items-center mb-2">
            <p className="pt-2 pb-2 mb-0">
              Select the Vendor to Assign the Assest
            </p>
          </div>
          <Form onSubmit={handleSubmit}>
            <Form.Group id="Vendor Name">
              <Form.Label>Vendor Name</Form.Label>
              <Select
                options={vendor.map((v) => ({
                  value: v.id, // Value to be stored
                  label: v.company_name, // Display text
                }))}
                value={
                  vendorId
                    ? {
                        value: vendorId,
                        label: vendor.find((v) => v.id === vendorId)
                          ?.company_name,
                      }
                    : null
                }
                onChange={(selectedOption) =>
                  setVendorID(selectedOption ? selectedOption.value : "")
                }
                placeholder="Select Vendor"
                isClearable // Allow clearing the selection
                isSearchable // Allow typing to filter options
                styles={{
                  control: (base) => ({
                    ...base,
                    borderRadius: "5px",
                    width: "100%",
                  }),
                }}
              />
            </Form.Group>
            {/*       
                        <Form.Group id="Vendor Name">
                                                 <Form.Label>Vendor Name</Form.Label>
                                                 <Form.Select
                                                   value={vendorId}
                                                   onChange={(e) => setVendorID(e.target.value)}
                                                 >
                                                   <option value="0">Select Vendor</option>
                                                   {vendor?.map((v) => (
                                                     <option key={v.id} value={v.id}>
                                                       {v.company_name}
                                                     </option>
                                                   ))}
                                                 </Form.Select>
                                               </Form.Group>
                       */}

            <div className="pt-3">
              <Button variant="primary" type="submit">
                Assign Assests
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};
